import { useState } from 'react';
import { faqList } from '@/mocks/manga';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
            <i className="ri-question-mark" /> 使用指南
          </span>
          <h2 className="font-display mt-3 text-2xl font-bold text-foreground-900 md:text-4xl">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            关于作品库、分类与排行的常见疑问，这里都有答案。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-6"
                >
                  <h3 className="flex items-center gap-3 text-sm font-semibold text-foreground-900 md:text-base">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                      Q
                    </span>
                    {item.q}
                  </h3>
                  <i
                    className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    } ri-arrow-down-s-line`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-4 py-4 pl-[52px] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[66px]">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}